import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { onChange, getCookie } from '../../../utils';
import CONSTANT from '../../../constant';
import Header from '../../../component/common/LeaveHeader';

import { getDateParts, setOptions } from '../../../utils';
import { getUnitList } from '../../../actions/MasterAction';
import { getOrganisationEncashmentRequest } from '../../../actions/LeaveAction';
import Shimmer from '../../../component/common/Shimmer';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            pending: undefined,
            others: undefined,
            unitCode: { name: 'unitCode', value: '', options: [], error: '', isRequired: true },
            unitCodeO: { name: 'unitCodeO', value: '', options: [], error: '', isRequired: true },
            date: moment(),
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allLeaves;
        getUnitList().then((res: any) => {
            setOptions(this, this.state.unitCode.name, res.result);
            setOptions(this, this.state.unitCodeO.name, res.result);
        });
        this.loadList();
    }

    render() {
        const { pending, others, date, unitCode, unitCodeO } = this.state;
        const ud = getCookie(CONSTANT.cookie.userDetail);

        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                    <div className="col-md-6">
                    <div className="alert alert-dismissible alert-danger">
                                    <ul className="pl-3 mb-0">
                                        <li>Leave Encashment Record - Corporate Office <a href="/excel/Leave_Encashment.xlsx" target="_blank">Click here to view/download</a></li>
                                    </ul>
                                </div>
                                </div>
                        <div className="row mt-3">
                            <div className="col-md-6">
                                <h1 className="page-title">Pending Request{pending && ` - ${pending.length}`}</h1>
                            </div>
                            {/* <div className="col-md-2">
                                
                            </div> */}
                            {/* <div className="col-md-2">
                                
                            </div> */}
                            <div className="col-md-3">
                                <input type="month" value={date.format('YYYY-MM')} onChange={this.onChange} className="form-control" />
                            </div>
                            <div className="col-md-3">
                                                <div className="form-group">
                                                    {/* <label>Sort By</label> */}
                                                    <select
                                                        value={unitCode.value}
                                                        className={unitCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        onChange={this.onChange1}
                                                        name={unitCode.name}>
                                                        <option value="">Sort By Unit</option>
                                                        {
                                                            unitCode.options.map((item: any, index: number) => {
                                                                return <option key={index} value={item.name}>{item.name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                {/* <th scope="col">Address</th> */}
                                                <th scope="col">Leave type</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Status</th>
                                                <th scope="col" title="HPL">Unit</th>
                                                <th scope="col">Modified</th>
                                            </tr>
                                            {
                                                pending === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                pending !== undefined && pending.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                            
                                                pending !== undefined && pending.filter((item: any) => unitCode.value ? item.unitName == unitCode.value : true).map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.adminOrganisationEncashmentRequestDetail.url.replace(':code', item.id);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            {/* <td>{item.addressTypeName}</td> */}
                                                            <td>{item.leaveTypeName}
                                                                {item.cancelled && <span className="badge badge-danger ml-1">Cancelled</span>}
                                                            </td>
                                                            <td>{item.numberOfDays}</td>
                                                            <td>
                                                                {
                                                                    item.statusId === null? <span>Pending</span> : <span>{item.statusId}</span>
                                                                }
                                                                {/* {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn === null && item.approved !== null ? (item.approved ? <span className="text-success">Approved</span> : <span className="text-danger">Rejected</span>) : null
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn === null && <span className="text-info">Cancellation Requested</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn !== null && <span className="text-danger">Leave Cancelled</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn !== null && (item.cancellationStatus ? <span className="text-success">Cancellation Approved</span> : <span className="text-danger">Cancellation Rejected</span>)
                                                                } */}
                                                            </td>
                                                            <td>{item.unitName}</td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div className="row mt-3">
                            <div className="col-md-9">
                                <h1 className="page-title">Others{others && ` - ${others.length}`}</h1>
                            </div>
                            <div className="col-md-3">
                                                <div className="form-group">
                                                    {/* <label>Sort By</label> */}
                                                    <select
                                                        value={unitCodeO.value}
                                                        className={unitCodeO.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        onChange={this.onChange1}
                                                        name={unitCodeO.name}>
                                                        <option value="">Sort By Unit</option>
                                                        {
                                                            unitCodeO.options.map((item: any, index: number) => {
                                                                return <option key={index} value={item.name}>{item.name}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                {/* <th scope="col">Address</th> */}
                                                <th scope="col">Leave type</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Status</th>
                                                <th scope="col" title="HPL">Unit</th>
                                                <th scope="col">Modified</th>
                                            </tr>
                                            {
                                                others === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                others !== undefined && others.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                others !== undefined && others.filter((item: any) => unitCodeO.value ? item.unitName == unitCodeO.value : true).map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.adminOrganisationEncashmentRequestDetail.url.replace(':code', item.id);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            {/* <td>{item.addressTypeName}</td> */}
                                                            <td>{item.leaveTypeName}
                                                                {item.cancelled && <span className="badge badge-danger ml-1">Cancelled</span>}
                                                            </td>
                                                            <td>{item.numberOfDays}</td>
                                                            <td>
                                                                {
                                                                    item.statusId !== null && item.statusId === 1? <span>Approved</span> : <span>Rejected</span>
                                                                }
                                                                {/* {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn === null && item.approved !== null ? (item.approved ? <span className="text-success">Approved</span> : <span className="text-danger">Rejected</span>) : null
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn === null && <span className="text-info">Cancellation Requested</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn !== null && <span className="text-danger">Leave Cancelled</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn !== null && (item.cancellationStatus ? <span className="text-success">Cancellation Approved</span> : <span className="text-danger">Cancellation Rejected</span>)
                                                                } */}
                                                            </td>
                                                            <td>{item.unitName}</td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>




                        {/* <div className="row">
                            <div className="col-md-2">
                                <button type="button" onClick={this.previousYear} className="btn btn-link btn-sm next-control btn-block">
                                    <i className="fa fa-angle-double-left mr-1 pe-none" aria-hidden="true"></i>
                                    Year {date.getFullYear() - 1}
                                </button>
                            </div>
                            <div className="col-md-8"></div>
                            <div className="col-md-2">
                                <button type="button" onClick={this.nextYear} className="btn btn-link btn-sm float-right next-control btn-block">
                                    Year {date.getFullYear() + 1}
                                    <i className="fa fa-angle-double-right ml-1 pe-none" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ date: moment(value), pending: undefined, others: undefined }, () => {
            this.loadList();
        });
        // onChange(this, e.target.name, e.target.value);
    }

    onChange1 = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        // this.setState({ date: moment(value), pending: undefined, others: undefined }, () => {
            // this.loadList();
        onChange(this, e.target.name, e.target.value);
    }

    loadList = () => {
        const { date } = this.state;
        getOrganisationEncashmentRequest(date.format('YYYY-MM-DD')).then((res: any) => {
            if (res) {
                this.setState({
                    pending: res.result.pending,
                    others: res.result.others
                });
            }
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }
}

export default ComponentName;